import qs from "qs";
import {
  addQueryParamsToUrl,
  isEnterPressed,
  isEscPressed,
} from "../lib/utils";
import { $DOCUMENT } from "../lib/constants";

const $input = $(".js-input-press:first");
const $inputBox = $input.parent();
const $searchBtn = $inputBox.find(".js-input-search-btn:first");
const $eraseBtn = $inputBox.find(".js-input-erase-btn:first");

const $selects = $(".js-select-press:first");
const $openSelectBtn = $selects.find(".js-select-current-btn");
const $selectBtns = $selects.find(".js-select-option");
const $nativeSelect = $selects.find(".js-select-native-select");

const restoreInputVal = () => {
  const { q } = qs.parse(window.location.search, { ignoreQueryPrefix: true });

  if (q) {
    $input.val(q);
  }
};

const restoreSelectPeriod = () => {
  const { period } = qs.parse(window.location.search, {
    ignoreQueryPrefix: true,
  });

  $.each($selectBtns, function (_, el) {
    const $btn = $(el);

    if ($btn.attr("data-period") === period) {
      $openSelectBtn.html($btn.text());

      $nativeSelect
        .find(`[value=${$btn.attr("data-id")}]`)
        .attr("selected", "selected");
    }
  });
};

const restoreDateRange = () => {
  const { to, from } = qs.parse(window.location.search, {
    ignoreQueryPrefix: true,
  });

  if (to && from) {
    if (to === from) {
      $openSelectBtn.text(`${from}`);
    } else {
      $openSelectBtn.text(`${from} - ${to}`);
    }
  }
};

const addPeriodParamToUrl = () => {
  $selectBtns.on("click", function () {
    const $btn = $(this);

    if ($btn.attr("data-period") !== "datepicker") {
      addQueryParamsToUrl({ period: $btn.attr("data-period") }, "period");
    }
  });
};

const deleteInputValFromUrlByEraseBtnPress = () => {
  $eraseBtn.on("click", function () {
    const search = qs.parse(window.location.search, {
      ignoreQueryPrefix: true,
    });

    if (search.q) {
      delete search.q;
      window.location.search = qs.stringify({ ...search });
    }
  });
};

export const pressCenterFunctions = () => {
  restoreInputVal();
  restoreSelectPeriod();
  restoreDateRange();
  addPeriodParamToUrl();
  deleteInputValFromUrlByEraseBtnPress();

  if ($input.length) {
    $searchBtn.on("click", function () {
      addQueryParamsToUrl({ q: $input.val() });
    });

    $input.on("keyup", (event) => {
      if (isEnterPressed(event)) {
        addQueryParamsToUrl({ q: $input.val() });
      }
    });
  }
};
